(function () {
    'use strict';

    angular
        .module('studyad')
        .config(StudyAdRoute);

    /* @ngInject */
    function StudyAdRoute($stateProvider) {
        $stateProvider
            .state ('root.studyad', {
                url: '/studyad',
                abstract: true
            })
            .state ('root.studyad.events', {
                url: '/events',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/studyad/reports/events/reportFilter.html',
                        controller: 'StudyAdEventsController',
                        controllerAs: 'studyAdEvents'
                    }
                }
            });
    }
})();